import SortableTaskItem from './SortableTaskItem';

export default SortableTaskItem;
